import * as XLSX from 'xlsx';

// Дата рождения из ячейки Excel → 'YYYY-MM-DD' (формат базы) или null.
//
// Excel хранит дату как число — номер дня от 1900 года (34679 = 11.12.1994),
// и в зависимости от формата ячейки и того, кто сохранял файл, в таблице
// попадаются ещё и строки: «11.12.1994», «1.2.1994», «11/12/1994», «1994-12-11»,
// с пробелами по краям, иногда с двузначным годом.
//
// Порядок в строках с точкой и слешем — день, месяц, год (как пишут у нас).

const pad = n => String(n).padStart(2, '0');

const toIso = (year, month, day) => {
    // Проверяем, что такая дата существует: 31.02 или 13-й месяц отбрасываем
    const check = new Date(Date.UTC(year, month - 1, day));
    if (
        check.getUTCFullYear() !== year
        || check.getUTCMonth() !== month - 1
        || check.getUTCDate() !== day
    ) {
        return null;
    }
    return `${year}-${pad(month)}-${pad(day)}`;
};

// Двузначный год: 94 → 1994, 05 → 2005 (если не позже текущего года)
const expandYear = (yy) => {
    const current = new Date().getFullYear() % 100;
    return yy > current ? 1900 + yy : 2000 + yy;
};

export const parseBirthday = (value, options = {}) => {
    if (value === null || value === undefined || value === '') return null;

    // Число — серийная дата Excel
    if (typeof value === 'number') {
        if (!isFinite(value) || value <= 0) return null;
        const parsed = XLSX.SSF.parse_date_code(value, { date1904: Boolean(options.date1904) });
        if (!parsed || !parsed.y) return null;
        return toIso(parsed.y, parsed.m, parsed.d);
    }

    // Объект даты — если файл прочитан с cellDates
    if (value instanceof Date) {
        if (isNaN(value.getTime())) return null;
        return toIso(value.getFullYear(), value.getMonth() + 1, value.getDate());
    }

    const text = String(value).trim();
    if (!text) return null;

    // Строка из одних цифр — серийная дата, сохранённая как текст
    if (/^\d{4,6}$/.test(text) && Number(text) > 1000 && Number(text) < 80000) {
        return parseBirthday(Number(text), options);
    }

    // ГГГГ-ММ-ДД (и с временем после даты)
    let match = text.match(/^(\d{4})[-./](\d{1,2})[-./](\d{1,2})(?:[T\s].*)?$/);
    if (match) {
        return toIso(Number(match[1]), Number(match[2]), Number(match[3]));
    }

    // ДД.ММ.ГГГГ, Д.М.ГГГГ, ДД/ММ/ГГГГ, ДД-ММ-ГГГГ, ДД ММ ГГГГ, а также с двузначным годом
    match = text.match(/^(\d{1,2})\s*[-./\s]\s*(\d{1,2})\s*[-./\s]\s*(\d{2}|\d{4})(?:\s*г\.?)?$/i);
    if (match) {
        const year = match[3].length === 2 ? expandYear(Number(match[3])) : Number(match[3]);
        return toIso(year, Number(match[2]), Number(match[1]));
    }

    return null;
};

// 'YYYY-MM-DD' → 'ДД.ММ.ГГГГ' для показа админу
export const formatRuDate = (iso) => {
    if (!iso) return '';
    const match = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
    return match ? `${match[3]}.${match[2]}.${match[1]}` : String(iso);
};

// Сравнение дат из базы и из файла: база может отдать дату с временем
export const sameDate = (a, b) => Boolean(a && b) && String(a).slice(0, 10) === String(b).slice(0, 10);
